<div class="update-order-modal" id="dark" [ngStyle]="
    translate.currentLang == 'ar' && { direction: 'rtl', 'text-align': 'start' }
  ">
  <div class="d-flex justify-content-between align-items-center">
    <h4 class="text-color-theme m-0">
      {{ "update-order" | translate }} {{ orderToUpdate.OrderNumber }}
    </h4>

    <span class="news-type-badge rounded-pill" [ngStyle]="getColor(orderToUpdate.TransactionId)">{{
      translate.currentLang == "en"
      ? orderToUpdate["TransactionTypeEn"]
      : orderToUpdate["TransactionTypeAr"]
      }}
    </span>
  </div>

  <div class="p-0 mt-4">
    <div class="d-flex justify-content-between">
      <span>
        ({{ orderToUpdate.Reuters }})
        {{
        translate.currentLang == "en"
        ? orderToUpdate.SymbolNameEn
        : orderToUpdate.SymbolNameAr
        }}
      </span>
      <span>
        {{ orderToUpdate.RelationCode }}
      </span>
    </div>
    <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center">
    <span  class="spinner-border spinner-border-sm mr-1"></span>
  </div>
    <div *ngIf="company" class="details-card">
      <div class="row" *ngIf="company.SYMBOL_CODE">
        <div class="col-md-12 d-flex flex-row justify-content-between">
          <div class="pb-1" style="font-weight: 500; text-align: start">
            {{ "last-price" | translate }}
            <span class="mx-1 last-price-color">{{
              company.LAST_TRADE_PRICE | number : "1.0" : "en-US"
              }}</span>
          </div>
          <!-- <div ngbTooltip="{{company.ENG_NAME}}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: start;">
            {{(translate.currentLang=='en')?company.ENG_NAME:company.ARB_NAME}}
          </div> -->
          <div [ngClass]="company.LAST_CHANGE_PRC > 0 ? 'green' : 'red'" style="text-align: end !important">
            {{ company.LAST_CHANGE | number : "1.0" : "en-US" }} ({{
            company.LAST_CHANGE_PRC | number : "1.0" : "en-US"
            }}%)
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-2" *ngIf="company.SYMBOL_CODE">
        <div>
          {{ "min-limit" | translate }}: {{ companyDetails?.MinLimit }}
        </div>
        <div>
          {{ "max-limit" | translate }}: {{ companyDetails?.MaxLimit }}
        </div>
      </div>
      <div class="d-flex justify-content-between mt-2" *ngIf="company.SYMBOL_CODE">
        <div>
          {{ "best-bid" | translate }}:
          <span>{{ company.BID_PRICE | number : "1.0" : "en-US" }}</span> /
          <span>{{ company.BID_VOLUME | number : "1.0" : "en-US" }}</span>
        </div>
        <div>
          {{ "best-ask" | translate }}:
          <span>{{ company.ASK_PRICE | number : "1.0" : "en-US" }}</span> /
          <span>{{ company.ASK_VOLUME | number : "1.0" : "en-US" }}</span>
        </div>
      </div>
      <div class="d-flex justify-content-between mt-1" style="font-size: 14px" *ngIf="company.SYMBOL_CODE">
        <div>
          {{ "close-price" | translate }}:
          <span>{{ company.CLOSE_PRICE | number : "1.0" : "en-US" }}</span>
        </div>
        <div *ngIf="
            companyDetails?.SameDayQty != null &&
            companyDetails?.SameDayQty != 0
          ">
          {{ "sameday-qty" | translate }}:
          <span> {{ companyDetails?.SameDayQty | number }}</span>
        </div>
      </div>
    </div>

    <form [formGroup]="updateOrderForm">
      <div class="form-group" *ngIf="!isLoading">
        <div class="row mt-4 mb-2">
          <div class="col-md-6">
            <div class="input-group mb-3 d-flex flex-column">
              <label>{{ "qty" | translate }}</label>
              <div>
                <input formControlName="qty" type="text" class="form-control" [ngClass]="
                    translate.currentLang == 'en'
                      ? 'number-input'
                      : 'number-input-ar'
                  " oninput="if(!this.value.match('^[1-9][0-9]*$'))this.value='';" (keypress)="numberOnly($event)"
                  style="border-radius: 5px"  />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="input-group mb-3">
              <div style="width: 100%;">
                 <div class="row w-100 justify-content-between m-0 align-items-center">
                  <div class="d-flex align-items-center">
                    <label>{{ "price" | translate }}</label>
                    <span *ngIf="isMarketPrice" class="badge badge-primary ml-2" style="font-size: 0.75rem;">MKT</span>
                  </div>
                  <button class="btn btn-sm btn-primary market-button" (click)="setMarketOrder()" *ngIf="
                      companyDetails?.MinLimit != 0 &&
                      companyDetails?.MinLimit != null &&
                      companyDetails?.MaxLimit != 0 &&
                      companyDetails?.MaxLimit != null
                    ">
                    {{ "market-price" | translate }}
                  </button>
                </div>
                <div *ngIf="!isMarketPrice">
                <input  [disabled]="isMarketPrice" formControlName="price" type="text" class="form-control" [ngClass]="{
                    'number-input': translate.currentLang == 'en',
                    'number-input-ar': translate.currentLang !== 'en',
                    'market-price-input': isMarketPrice
                  }" (keypress)="priceDecimalInput($event)" style="border-radius: 5px" />
                </div>
                <div *ngIf="isMarketPrice">
                  <input type="text" 
                    class="form-control market-price-display" 
                    [value]="translate.currentLang == 'en' ? 'MKT' : 'سعر السوق'"
                    disabled 
                    style="border-radius: 5px" />                 
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <label>{{ "valid-till" | translate }}</label>
            <select formControlName="validTill" #validTill class="form-control">
              <option value="0">{{ "Today" | translate }}</option>
              <option value="6"  *ngIf="!userProfile?.OpenOrderRestriction">{{ "TillDate" | translate }}</option>
              <option value="1"  *ngIf="!userProfile?.OpenOrderRestriction">{{ "TillCancel" | translate }}</option>
            </select>
            <div class="openOrderRestriction-text" [ngClass]="{'hidden': !userProfile?.OpenOrderRestriction}">
              {{
                "openOrdersDisabled" | translate
                }}
            </div>
          </div>

          <div class="col-md-6" *ngIf="validTill.value == 6">
            <label>{{ "select-date" | translate }}</label>

            <div>
              <input [min]="today" (focus)="picker.open()" class="form-control" #date id="date" matInput
                formControlName="tiffDate" [matDatepicker]="picker" />
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </div>
      </div>


      <div class="row" *ngIf="!isLoading">
        <div class="col justify-content-between">
          <span class="text-muted" style="font-size: smaller">
            {{ "purchase-power" | translate }} </span>
          <span *ngIf="company.CURRENCY == 1 && clientData" [ngClass]="
          clientData.purchasePower.EGP < 0
            ? 'red'
            : ''
        ">
            <br />
            {{ clientData.purchasePower.EGP | currency : "EGP" }}
          </span>
          <span *ngIf="company.CURRENCY == 2 && clientData">
            {{ clientData.purchasePower.USD | currency : "USD" }}
          </span>
          <span *ngIf="!clientData" class="text-muted">
            <label> <br />
              {{ "select-account" | translate }}</label>
          </span>


        </div>




        <!-- Order Value on the Left -->
        <div class="col "
          [ngClass]="{ 'text-left': translate.currentLang === 'en', 'text-right': translate.currentLang !== 'en' }">
          <span class="text-muted" style="font-size: smaller">
            {{ "order-value" | translate }}
          </span>
          <br />

          <span>

            {{ orderTotal | number : "1.2-2" : "en-US" }}
          </span>
        </div>


      </div>


      <div class="row" *ngIf="!isLoading">

        <!-- Order Fees on the Right -->
        <div class="col "
          [ngClass]="{ 'text-left': translate.currentLang === 'en', 'text-right': translate.currentLang !== 'en' }"
          *ngIf="orderToUpdate.FixVal === '1'">
          <span class="text-muted" style="font-size: smaller">
            {{ "order-fees" | translate }}
          </span>
          <br />
          <span>
            {{ orderFees | number : "1.2-2" : "en-US" }}
          </span>
        </div>


        <!-- Order total Cost on the Right -->
        <div class="col "
          [ngClass]="{ 'text-left': translate.currentLang === 'en', 'text-right': translate.currentLang !== 'en' }"
          *ngIf="orderToUpdate.FixVal === '1'">
          <span class="text-muted" style="font-size: smaller">
            {{ 'total-cost' | translate }}
          </span>
          <br />
          <span>
            {{ totalCost | number: '1.2-2' : 'en-US' }}
          </span>
        </div>



      </div>
      <div *ngIf="isExceedingLimits() && totalCost!=initalTotalCost" class="text-danger text-center">
        {{ 'order-value-exceeded-purchase' | translate }}
      </div>      


      <mat-dialog-actions align="center" *ngIf="!isLoading">
        <button class="btn edit-btn-bg text-center mx-2" [disabled]="(isExceedingLimits() && totalCost!=initalTotalCost) || isSubmitting"
          [confirmText]="confirmText" [cancelText]="cancelText" mwlConfirmationPopover [popoverMessage]="popoverMessage"
          placement="right" (confirm)="submitOrder()">
          {{ "update" | translate }}
          <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
        </button>

        <!-- <button class="btn btn-primary text-center mx-2" type="submit" tabindex="1">{{'submit' | translate}}</button> -->
        <button class="btn btn-danger text-center" mat-dialog-close>
          {{ "cancel" | translate }}
        </button>
      </mat-dialog-actions>
    </form>
  </div>

  <div id="dark" class="d-flex justify-content-center" *ngIf="!orderToUpdate">
    <div class="spinner-border text-secondary m-5" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
</div>